module.exports = __webpack_public_path__ + "static/media/10UNOHRLLS3.499b63bd.jpg";